import { render, staticRenderFns } from "./LongTextChart.vue?vue&type=template&id=67b3726c"
import script from "./LongTextChart.vue?vue&type=script&lang=js"
export * from "./LongTextChart.vue?vue&type=script&lang=js"
import style0 from "./LongTextChart.vue?vue&type=style&index=0&id=67b3726c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports